__turbopack_context__.v({
  "actionCopy": "youtube-kalshi-module__SqhXTW__actionCopy",
  "actionGuide": "youtube-kalshi-module__SqhXTW__actionGuide",
  "activeBrowserTab": "youtube-kalshi-module__SqhXTW__activeBrowserTab",
  "amountField": "youtube-kalshi-module__SqhXTW__amountField",
  "amountPresets": "youtube-kalshi-module__SqhXTW__amountPresets",
  "author": "youtube-kalshi-module__SqhXTW__author",
  "backButton": "youtube-kalshi-module__SqhXTW__backButton",
  "brand": "youtube-kalshi-module__SqhXTW__brand",
  "browserAddress": "youtube-kalshi-module__SqhXTW__browserAddress",
  "browserDots": "youtube-kalshi-module__SqhXTW__browserDots",
  "browserTabs": "youtube-kalshi-module__SqhXTW__browserTabs",
  "celebration": "youtube-kalshi-module__SqhXTW__celebration",
  "celebrationDescription": "youtube-kalshi-module__SqhXTW__celebrationDescription",
  "celebrationIcon": "youtube-kalshi-module__SqhXTW__celebrationIcon",
  "celebrationNote": "youtube-kalshi-module__SqhXTW__celebrationNote",
  "celebrationTitle": "youtube-kalshi-module__SqhXTW__celebrationTitle",
  "chart": "youtube-kalshi-module__SqhXTW__chart",
  "chartGrid": "youtube-kalshi-module__SqhXTW__chartGrid",
  "chartTimes": "youtube-kalshi-module__SqhXTW__chartTimes",
  "coach": "youtube-kalshi-module__SqhXTW__coach",
  "coachIcon": "youtube-kalshi-module__SqhXTW__coachIcon",
  "completion": "youtube-kalshi-module__SqhXTW__completion",
  "completionIcon": "youtube-kalshi-module__SqhXTW__completionIcon",
  "ctaActions": "youtube-kalshi-module__SqhXTW__ctaActions",
  "editOrder": "youtube-kalshi-module__SqhXTW__editOrder",
  "eyebrow": "youtube-kalshi-module__SqhXTW__eyebrow",
  "faqs": "youtube-kalshi-module__SqhXTW__faqs",
  "finalCta": "youtube-kalshi-module__SqhXTW__finalCta",
  "findTarget": "youtube-kalshi-module__SqhXTW__findTarget",
  "guideActions": "youtube-kalshi-module__SqhXTW__guideActions",
  "header": "youtube-kalshi-module__SqhXTW__header",
  "headerCta": "youtube-kalshi-module__SqhXTW__headerCta",
  "hero": "youtube-kalshi-module__SqhXTW__hero",
  "heroActions": "youtube-kalshi-module__SqhXTW__heroActions",
  "heroProof": "youtube-kalshi-module__SqhXTW__heroProof",
  "intro": "youtube-kalshi-module__SqhXTW__intro",
  "kalshiChance": "youtube-kalshi-module__SqhXTW__kalshiChance",
  "kalshiConfirm": "youtube-kalshi-module__SqhXTW__kalshiConfirm",
  "kalshiGrid": "youtube-kalshi-module__SqhXTW__kalshiGrid",
  "kalshiMarket": "youtube-kalshi-module__SqhXTW__kalshiMarket",
  "kalshiMarketSub": "youtube-kalshi-module__SqhXTW__kalshiMarketSub",
  "kalshiNav": "youtube-kalshi-module__SqhXTW__kalshiNav",
  "kalshiOutcome": "youtube-kalshi-module__SqhXTW__kalshiOutcome",
  "kalshiShell": "youtube-kalshi-module__SqhXTW__kalshiShell",
  "kalshiSubnav": "youtube-kalshi-module__SqhXTW__kalshiSubnav",
  "lessonContent": "youtube-kalshi-module__SqhXTW__lessonContent",
  "lessonFacts": "youtube-kalshi-module__SqhXTW__lessonFacts",
  "loading": "youtube-kalshi-module__SqhXTW__loading",
  "marketCategory": "youtube-kalshi-module__SqhXTW__marketCategory",
  "maxPayout": "youtube-kalshi-module__SqhXTW__maxPayout",
  "microcopy": "youtube-kalshi-module__SqhXTW__microcopy",
  "noPill": "youtube-kalshi-module__SqhXTW__noPill",
  "openPracticeBrowser": "youtube-kalshi-module__SqhXTW__openPracticeBrowser",
  "orderGuide": "youtube-kalshi-module__SqhXTW__orderGuide",
  "orderNumbers": "youtube-kalshi-module__SqhXTW__orderNumbers",
  "outcomeLesson": "youtube-kalshi-module__SqhXTW__outcomeLesson",
  "page": "youtube-kalshi-module__SqhXTW__page",
  "practiceBrowser": "youtube-kalshi-module__SqhXTW__practiceBrowser",
  "practiceSection": "youtube-kalshi-module__SqhXTW__practiceSection",
  "practiceTag": "youtube-kalshi-module__SqhXTW__practiceTag",
  "priceBridge": "youtube-kalshi-module__SqhXTW__priceBridge",
  "priceExperiment": "youtube-kalshi-module__SqhXTW__priceExperiment",
  "primary": "youtube-kalshi-module__SqhXTW__primary",
  "progressRow": "youtube-kalshi-module__SqhXTW__progressRow",
  "progressTrack": "youtube-kalshi-module__SqhXTW__progressTrack",
  "proofDisclaimer": "youtube-kalshi-module__SqhXTW__proofDisclaimer",
  "proofPeriod": "youtube-kalshi-module__SqhXTW__proofPeriod",
  "proofSummary": "youtube-kalshi-module__SqhXTW__proofSummary",
  "proofThumb": "youtube-kalshi-module__SqhXTW__proofThumb",
  "recap": "youtube-kalshi-module__SqhXTW__recap",
  "receiptCopy": "youtube-kalshi-module__SqhXTW__receiptCopy",
  "receiptGrid": "youtube-kalshi-module__SqhXTW__receiptGrid",
  "receiptSection": "youtube-kalshi-module__SqhXTW__receiptSection",
  "reviewHeading": "youtube-kalshi-module__SqhXTW__reviewHeading",
  "ruleText": "youtube-kalshi-module__SqhXTW__ruleText",
  "ruleToggle": "youtube-kalshi-module__SqhXTW__ruleToggle",
  "secondary": "youtube-kalshi-module__SqhXTW__secondary",
  "sectionHeading": "youtube-kalshi-module__SqhXTW__sectionHeading",
  "sideToggle": "youtube-kalshi-module__SqhXTW__sideToggle",
  "simulationBadge": "youtube-kalshi-module__SqhXTW__simulationBadge",
  "statusDot": "youtube-kalshi-module__SqhXTW__statusDot",
  "stepNav": "youtube-kalshi-module__SqhXTW__stepNav",
  "textButton": "youtube-kalshi-module__SqhXTW__textButton",
  "ticket": "youtube-kalshi-module__SqhXTW__ticket",
  "ticketBody": "youtube-kalshi-module__SqhXTW__ticketBody",
  "ticketFootnote": "youtube-kalshi-module__SqhXTW__ticketFootnote",
  "ticketGame": "youtube-kalshi-module__SqhXTW__ticketGame",
  "ticketMessage": "youtube-kalshi-module__SqhXTW__ticketMessage",
  "ticketTabs": "youtube-kalshi-module__SqhXTW__ticketTabs",
  "videoLink": "youtube-kalshi-module__SqhXTW__videoLink",
  "walkthrough": "youtube-kalshi-module__SqhXTW__walkthrough",
  "yesPill": "youtube-kalshi-module__SqhXTW__yesPill",
});
